import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const FirebaseTest: React.FC = () => {
  const [users, setUsers] = useState<any[]>([]);
  const [classes, setClasses] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    testFirebaseConnection();
  }, []);

  const testFirebaseConnection = async () => {
    try {
      setLoading(true);
      setError(null);

      // Test users collection
      console.log('Testing users collection...');
      const usersSnapshot = await getDocs(collection(db, 'users'));
      const usersData = usersSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setUsers(usersData);
      console.log('Users found:', usersData.length);

      // Test classes collection
      console.log('Testing classes collection...');
      const classesSnapshot = await getDocs(collection(db, 'classes'));
      const classesData = classesSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setClasses(classesData);
      console.log('Classes found:', classesData.length);

    } catch (err: any) {
      console.error('Firebase connection error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Testing Firebase connection...</div>;
  }

  if (error) {
    return (
      <div style={{ color: 'red', padding: '20px' }}>
        <h3>Firebase Connection Error:</h3>
        <p>{error}</p>
        <button onClick={testFirebaseConnection}>Retry Connection</button>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px' }}>
      <h2>Firebase Connection Test</h2>
      <div style={{ marginBottom: '20px' }}>
        <h3>Users Collection ({users.length} users)</h3>
        {users.map(user => (
          <div key={user.id} style={{ margin: '10px 0', padding: '10px', border: '1px solid #ccc' }}>
            <strong>{user.displayName || user.name || 'Unknown'}</strong>
            <br />
            Email: {user.email}
            <br />
            Role: {user.role}
            <br />
            Class: {user.classGroup || user.classCode || 'N/A'}
          </div>
        ))}
      </div>

      <div>
        <h3>Classes Collection ({classes.length} classes)</h3>
        {classes.map(cls => (
          <div key={cls.id} style={{ margin: '10px 0', padding: '10px', border: '1px solid #ccc' }}>
            <strong>{cls.name}</strong>
            <br />
            Code: {cls.code}
            <br />
            Teacher: {cls.teacherName}
            <br />
            Students: {cls.studentIds?.length || 0}
            <br />
            Parents: {cls.parentIds?.length || 0}
          </div>
        ))}
      </div>

      <button onClick={testFirebaseConnection} style={{ marginTop: '20px' }}>
        Refresh Data
      </button>
    </div>
  );
};

export default FirebaseTest; 